export const inventoryErrorTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('Exception thrown while loading an object in an inventory.') !== -1 || desyncdata.indexOf('Error during inventory load (RuntimeError') !== -1) {
			return {
				type: 'inventoryErrorTest',
				color: 'Goldenrod',
				title: 'Inventory Object Loading Error',
				text: 'Base game issue with loading an object in an inventory of a Sim or a container.',
				description: 'This error can occur when an object that is being loaded has changed its data structure or the loaded object comes from a modification and fails to spawn into the world. This can result in the loaded inventory being empty. If the game loaded without anything missing, you\'re safe to ignore this error.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>8203399f8b0dedb15b617266</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-08-01 13:03:25</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.62.1020-1.200.000.360.Release</buildsignature>
        <categoryid>log.py:836</categoryid>
        <desyncid>8203399f8b0dedb15b617266</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>[tingyul] Exception thrown while loading an object in an inventory. 
Object: object_Food_HotDog_Single:0x0bc007b4485e29d1 Owner:  (AssertionError: [Object Manager] [tingyul] Attempting to move an object object_Food_HotDog_Single:0x0bc007b4485e29d1 that is not in this manager or not the same object object_Food_HotDog_Single:0x0bc007b4485e29d1 in manager)
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 113, in wrapped
  File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 109, in finally_wrap
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 157, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 175, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 356, in c_api_client_connect
  File &quot;T:\InGame\Gameplay\Scripts\Server\zone.py&quot;, line 548, in do_zone_spin_up
  File &quot;T:\InGame\Gameplay\Scripts\Server\zone_spin_up_service.py&quot;, line 1256, in update
  File &quot;T:\InGame\Gameplay\Scripts\Server\zone_spin_up_service.py&quot;, line 579, in on_enter
  File &quot;T:\InGame\Gameplay\Scripts\Server\sims\sim_spawner_service.py&quot;, line 639, in batch_spawn_during_zone_spin_up
  File &quot;T:\InGame\Gameplay\Scripts\Server\sims\sim_info.py&quot;, line 1661, in create_sim_instance
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\system.py&quot;, line 183, in create_object
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\object_manager.py&quot;, line 487, in add
  File &quot;T:\InGame\Gameplay\Scripts\Server\indexed_manager.py&quot;, line 164, in add
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\object_manager.py&quot;, line 84, in call_on_add
  File &quot;T:\InGame\Gameplay\Scripts\Server\indexed_manager.py&quot;, line 279, in call_on_add
  File &quot;T:\InGame\Gameplay\Scripts\Server\sims\sim.py&quot;, line 2365, in on_add
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\inventory.py&quot;, line 681, in load_items
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\sim_inventory_component.py&quot;, line 117, in _load_item
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\inventory.py&quot;, line 691, in _create_inventory_object
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\system.py&quot;, line 191, in create_object
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\inventory.py&quot;, line 691, in &lt;lambda&gt;
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\inventory.py&quot;, line 714, in _post_create_object
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\inventory.py&quot;, line 709, in _post_create_object
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\inventory.py&quot;, line 323, in add_from_load
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\inventory.py&quot;, line 339, in _insert_item
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\inventory_storage.py&quot;, line 170, in insert
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\components\inventory_storage.py&quot;, line 273, in _insert
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\object_manager.py&quot;, line 479, in move_to_inventory
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\log.py&quot;, line 836, in assert_raise
AssertionError: [Object Manager] [tingyul] Attempting to move an object object_Food_HotDog_Single:0x0bc007b4485e29d1 that is not in this manager or not the same object object_Food_HotDog_Single:0x0bc007b4485e29d1 in manager
</desyncdata>
    </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/basegame/inventoryErrorTest.js